import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMD_BUILDOVERVIEW_REGISTRY_KEY, META_TYPE, META_VER } from './buildOverviewCommandRegisteryType';

/**
 * Registers the /builds command with the CommandEngine.
 * /builds — opens/refocuses the build overview (single instance, target=builds).
 */
export function registerBuildOverviewCommand() {
    commandEngine.register('/builds', {
        hint: 'open build overview (last result per job)',
        params: [],
        handler: () => {
            cardPainterManager.openCard(CMD_BUILDOVERVIEW_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: 'builds' }, {});
        },
    });
}
